import { makeStyles } from '@rbx/ui';

const useDialogStyles = makeStyles()((theme) => ({
  container: {
    padding: theme.spacing(3),
    width: 600,
    maxWidth: '100%',
    textAlign: 'center',
    background: theme.palette.background.media,
  },

  divider: {
    margin: theme.spacing(3, 0),
  },

  content: {
    marginBottom: theme.spacing(3),
    color: theme.palette.text.secondary,
  },

  buttonWrapper: {
    textAlign: 'center',
  },

  returnHome: {
    display: 'block',
    marginTop: theme.spacing(4),
  },
}));

export default useDialogStyles;
